import { useParams } from "react-router-dom"
import { getMapLinkColumn } from "../../../../widgets/table/tableFeatures/tableTemplates/tableColumnTemplates"
import { useDispatch } from "react-redux"
import { useEffect, useState } from "react"
import { useGetTableValueQuery } from "../../../../api/rtk/base/slices/tablesApiSlice"
import { showToastMessage } from "../../../../stateManagement/reducers"
import TableTitleRow from "../../../../widgets/table/tableAddons/tableTitleRow/TableTitleRow"
import ToastMessageContainer from "../../../../widgets/toastMessageContainer/ToastMessageContainer"
import LoaderWrapper from "../../../../widgets/loaderWrapper/LoaderWrapper"
import TableWidget from "../../../../widgets/table/tableWidget/TableWidget"
import { getValueWithMapLinks, prepareTableData } from "../../../../features/dataFormatFunctions/dataFormatter"
import { configureTableLazyState, defineTableColumnsFromArray, defineTableFilters } from "../../../../widgets/table/tableFeatures/tableFunctions"

const columnsStructure: any = [
    {
        headerName: "Кадастровый номер",
        field: "CommonCadastralNumber",
        align: "center",
        valueType: "int",
    },
    {
        headerName: "Представленная площадь",
        field: "Square",
        align: "right",
        valueType: "int",
    },
    getMapLinkColumn()
]

export default function TableNestedLandSubLotObjects() {
    const objectTypeName = "LandSubLotObjects"
    const { landLotId } = useParams()
    const dispatch = useDispatch()
    const [tableState, setTableState] = useState<any>(null)
    const [tableValue, setTableValue] = useState<any>([])
    const [columns, setColumns] = useState<any>([])

    const { data: landSubLots, isFetching: isFetchingLandSubLots, isError: isErrorLandSubLots } = useGetTableValueQuery({
        tableValueUrl: "objects/LandSubLotObjects",
        filterStringArray: [`ParentLotId eq ${landLotId}`],
        pages: true
    }, { skip: !landLotId })

    useEffect(() => {
        let columns = defineTableColumnsFromArray(columnsStructure)
        let filters = defineTableFilters(columns)
        setColumns(columns)
        setTableState(configureTableLazyState({ filters }))
    }, [])

    useEffect(() => {
        if (landSubLots && columns) {
            let value = landSubLots?.value
            value = getValueWithMapLinks(value, objectTypeName)
            value = prepareTableData(value, columns)
            setTableValue(value)
        }
    }, [landSubLots, columns])

    useEffect(() => {
        if (isErrorLandSubLots) {
            dispatch(showToastMessage({ messageText: "Ошибка загрузки таблицы", messageType: "error", windowType: "landSubLotObjectsTable" }))
        }
    }, [isErrorLandSubLots])

    return (
        <div className="table-widget-with-toast half-size">
            <TableTitleRow text="Участки в составе ЕЗП" />
            <ToastMessageContainer windowType="landSubLotObjectsTable" />
            <LoaderWrapper isLoading={isFetchingLandSubLots} className="table-with-title-row" >
                <TableWidget
                    tableValue={tableValue}
                    tableState={tableState}
                    columns={columns}
                    pageSize={100}
                    withTitleRow
                />
            </LoaderWrapper>
        </div>
    )
}
